var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.323,
    height: 10.701,
    viewBox: "0 0 8.323 10.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M3.719,11.387a1.192,1.192,0,0,0,1.189,1.189H9.664a1.192,1.192,0,0,0,1.189-1.189V4.253H3.719ZM5.182,7.154l.838-.838,1.266,1.26,1.26-1.26.838.838-1.26,1.26,1.26,1.26-.838.838-1.26-1.26-1.26,1.26-.838-.838,1.26-1.26L5.182,7.154ZM9.367,2.469l-.594-.594H5.8l-.594.594H3.125V3.658h8.323V2.469Z",
    transform: "translate(-3.125 -1.875)",
    fill: "#185cff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDelete);
export default __webpack_public_path__ + "static/media/manage-delete.6824a431b803b859d2cfc62e04048fa9.svg";
export { ForwardRef as ReactComponent };